import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Card, Form, Input, Button, Typography, message } from 'antd';
import { PhoneOutlined, LockOutlined, LoginOutlined, TrophyOutlined } from '@ant-design/icons';
import { driverService } from '../../common/services/api';
import './DriverPage.css';

const { Title, Paragraph, Text } = Typography;

const DriverLoginPage = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            // Ajouter le préfixe +225 si pas déjà présent
            let phone = values.phone.replace(/\s/g, '');
            if (!phone.startsWith('+')) {
                phone = '+225' + phone;
            }

            const response = await driverService.login(phone, values.password);
            if (response.success) {
                // Stocker les infos du chauffeur
                localStorage.setItem('driverToken', response.data.accessToken);
                localStorage.setItem('driverUser', JSON.stringify(response.data));
                message.success('Connexion reussie !');
                navigate('/chauffeurs/classement');
            } else {
                message.error(response.message || 'Erreur de connexion');
            }
        } catch (error) {
            message.error(error.message || 'Identifiants incorrects');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="driver-login-page">
            <div className="login-container">
                <Card className="login-card">
                    <div className="login-header">
                        <TrophyOutlined className="trophy-icon" />
                        <Title level={2}>Classement Chauffeurs</Title>
                        <Paragraph>
                            Connectez-vous pour voir votre position dans le classement mensuel
                        </Paragraph>
                    </div>

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={false}
                    >
                        <Form.Item
                            name="phone"
                            label="Telephone"
                            rules={[{ required: true, message: 'Veuillez entrer votre numero' }]}
                        >
                            <Input
                                addonBefore="+225"
                                placeholder="07 00 00 00 00"
                                size="large"
                                maxLength={10}
                                onChange={(e) => {
                                    // Garder uniquement les chiffres
                                    const cleanValue = e.target.value.replace(/\D/g, '');
                                    form.setFieldValue('phone', cleanValue);
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            label="Mot de passe"
                            rules={[{ required: true, message: 'Veuillez entrer votre mot de passe' }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="Votre mot de passe"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                size="large"
                                block
                                loading={loading}
                                icon={<LoginOutlined />}
                            >
                                Se connecter
                            </Button>
                        </Form.Item>
                    </Form>

                    <div className="login-footer">
                        <Text type="secondary">
                            <Link to="/chauffeurs/classement">Voir le classement public</Link>
                        </Text>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default DriverLoginPage;
